export default __webpack_public_path__ + "static/media/logo.db14d736.svg";